import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");

      if (!sessionId) {
        toast.error("Authentication failed");
        navigate("/", { replace: true });
        return;
      }

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId }
        );

        // Store session token as fallback for cookie-based auth
        if (response.data.session_token) {
          localStorage.setItem("session_token", response.data.session_token);
        }

        setUser(response.data);
        toast.success(`Welcome, ${response.data.name}!`);
        
        // Clear hash and navigate based on role
        window.history.replaceState(null, "", window.location.pathname);
        const role = response.data.role;
        let redirect = "/dashboard";
        if (role === "driver") redirect = "/driver";
        else if (role === "admin" || role === "super_admin") redirect = "/admin";
        navigate(redirect, { replace: true, state: { user: response.data } });
      } catch (error) {
        // Auth error handled by toast
        toast.error("Authentication failed");
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-white/60">Authenticating...</p>
      </div>
    </div>
  );
}
